import axios from 'axios';
import { useStore } from '../store';

console.log(process.env.REACT_APP_PORTAL_API_URL);

const request = axios.create({
  baseURL: process.env.REACT_APP_PORTAL_API_URL
});

export const AXIOS_INSTANCE_LOCAL = axios.create({
  baseURL: process.env.REACT_APP_API_URL_LOCAL
});

export const AXIOS_INSTANCE_ZEWARDS = axios.create({
  baseURL: process.env.REACT_APP_ZEWARDS_API_URL
});

export const AXIOS_INSTANCE_ONBOARDING = axios.create({
  baseURL: process.env.REACT_APP_REVAMP_API_URL
});

export const DeploymentClient = axios.create({
  baseURL: process.env.REACT_APP_DEPLOYMENT_API_URL
});

export const AXIOS_INSTANCE_CUSTOMER_ORDERS = axios.create({
  baseURL: process.env.REACT_APP_CUSTOMER_API_URL
});

export const AXIOS_INSTANCE_ODS = axios.create({
  baseURL: process.env.REACT_APP_ODS_API_URL
});

request.interceptors.request.use(async (config) => {
  const { token } = useStore.getState() || null;
  config.headers['Content-Type'] = 'application/json';
  // config.headers['ngrok-skip-browser-warning'] = false;
  if (token !== null) config.headers['Authorization'] = `bearer ${token}`;
  return config;
});

AXIOS_INSTANCE_ONBOARDING.interceptors.request.use(async (config) => {
  const { token } = useStore.getState() || null;
  config.headers['Content-Type'] = 'application/json';
  // config.headers['ngrok-skip-browser-warning'] = false;
  if (token !== null) config.headers['Authorization'] = `bearer ${token}`;
  return config;
});

AXIOS_INSTANCE_CUSTOMER_ORDERS.interceptors.request.use(async (config) => {
  const { token } = useStore.getState() || null;
  config.headers['Content-Type'] = 'application/json';
  // config.headers['ngrok-skip-browser-warning'] = false;
  if (token !== null) config.headers['Authorization'] = `bearer ${token}`;
  return config;
});

AXIOS_INSTANCE_ODS.interceptors.request.use(async (config) => {
  const { token } = useStore.getState() || null;
  config.headers['Content-Type'] = 'application/json';
  // config.headers['ngrok-skip-browser-warning'] = false;
  if (token !== null) config.headers['Authorization'] = `bearer ${token}`;
  return config;
});

export const client = request;
